import { DefaultActive, SchedulerData, SchedulerSegment } from './types';
import { getDividedHours, getFirstHour, getHours } from '@components/scheduler/grid/helpers';
import { defaultAppearance } from '@forms/panel/workflows/task/constants';
import { set } from 'date-fns';
import { tenantNow } from '@utils/timeZone';

export const START_HOUR: number = 6;
export const HOURS_COUNT: number = 13;

const getTodayAt = (hours: number) =>
  set(tenantNow(), { hours, minutes: 0, seconds: 0, milliseconds: 0 }).toISOString();

export const getDefaultStartsAt = () => getTodayAt(6);

export const getDefaultEndsAt = () => getTodayAt(18);

export const defaultActive: DefaultActive = {
  schedule: {
    id: '',
    foreman: { id: '' },
    startsAt: '',
    endsAt: '',
    status: '',
    task: {
      id: '',
      name: '',
      job: {
        id: '',
        projectId: '',
        name: '',
        address: '',
        division: { id: '', name: '' },
      },
      stage: {
        id: '',
        name: '',
      },
      appearance: defaultAppearance,
    },
  },
  newValues: {},
  fresh: false,
  foremanChanged: false,
  mode: 'move',
  initialX: 0,
  cursor: 'cursor-auto',
  x: 0,
  y: 0,
};

const initialSegment: SchedulerSegment = {
  length: 15,
  count: 60 / 15,
  width: `calc(100%/${60 / 15})`,
};

export const initialState: SchedulerData = {
  segment: initialSegment,
  dayStart: START_HOUR,
  hoursCount: HOURS_COUNT,
  showFullDay: false,
  showFullDayOverridden: false,
  outOfScopeRecords: false,
  date: getFirstHour(new Date()),
  data: {
    raw: {
      foremen: [],
      withoutTeam: [],
    },
    grouped: {
      foremen: [],
      withoutTeam: [],
    },
  },
  hours: getDividedHours(getHours(new Date()), initialSegment),
  modal: false,
  inventory: false,
  active: defaultActive,
};
